import { CorpTypeList2 } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TypeTableHead } from "../../type/componentsType/TkTable";
import { TkGetCodeList } from "../../utils/TkGetCode";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者名称の変更年月日",
    keyword: "changeDate",
    type: "date",
    disabled: true,
  },
  {
    title: "（新）経営者種別",
    keyword: "newType",
    type: "selectForm",
    selectPropsList: TkGetCodeList(CorpTypeList2),
    disabled: true,
  },
  {
    title: "（旧）経営者種別",
    keyword: "oldType",
    type: "text",
    disabled: true,
  },
  {
    title: "（新）契約者名称（ｶﾅ）",
    keyword: "newNameKana",
    type: "label",
    disabled: true,
  },
  {
    title: "（旧）契約者名称（ｶﾅ）",
    keyword: "oldNameKana",
    type: "text",
    disabled: true,
  },
  {
    title: "（新）契約者名称",
    keyword: "newName",
    type: "label",
    disabled: true,
  },
  {
    title: "（旧）契約者名称",
    keyword: "oldName",
    type: "text",
    disabled: true,
  },
  {
    title: "代表者職名",
    keyword: "directorTitle",
    type: "label",
    disabled: true,
  },
  {
    title: "代表者氏名",
    keyword: "directorName",
    type: "label",
    disabled: true,
  },
  {
    title: "履歴事項全部証明書（写）",
    keyword: "historyCertificate",
    type: "downloadLink",
    dataname: "",
    downloadBase64: true,
    base64filedata: "",
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "主たる事務所の所在地の変更年月日",
    keyword: "locationChangeDate",
    type: "date",
    disabled: true,
  },
  {
    title: "（新）郵便番号",
    keyword: "zipcode",
    type: "postcode",
    disabled: true,
  },
  {
    title: "（新）主たる事務所の所在地",
    keyword: "newPrefectures",
    type: "locationGroup",
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
    disabled: true,
  },
  {
    title: "（旧）主たる事務所の所在地",
    keyword: "oldLocation",
    type: "text",
    disabled: true,
  },
  {
    keyword: "lineTitleOther",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "共済契約証書再交付申出",
    keyword: "againReissue",
    type: "nodeInLine",
  },
];

const headList: TypeTableHead[] = [
  {
    headTitle: "帳票名",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
];

export { fakeTableList, headList };
